import { documents } from '@/routes/documents';
import { uiLib } from '@/routes/uiLib';
import { editor } from '@/routes/editor';
import { gatesAndLogin } from '@/routes/gatesAndLogin';
import { home } from '@/routes/home';
import { insights } from '@/routes/insights';
import { jobArchitecture } from '@/routes/jobArchitecture';
import { jobProfiles } from '@/routes/jobProfiles';
import { legacy } from '@/routes/legacy';
import { requisitions } from '@/routes/requisitions';
import { settings } from '@/routes/settings';
import DatapeopleAnywhereLoginSuccess from '@/views/DatapeopleAnywhereLoginSuccess.vue';
import DatapeopleFrame from '@/views/DatapeopleFrame.vue';

export const getRouterConfig = ({ authDataStore }) => ([
  {
    path: '/',
    component: DatapeopleFrame,
    children: [
      ...home(authDataStore),
      ...documents(authDataStore),
      ...legacy,
      ...requisitions(authDataStore),
      ...insights(authDataStore),
      ...settings(authDataStore),
      ...editor(authDataStore),
      ...jobArchitecture(authDataStore),
      ...jobProfiles(authDataStore),
      ...uiLib(),
    ],
  },
  ...gatesAndLogin,
  {
    path: '/datapeople-anywhere-login-success',
    name: 'datapeople-anywhere-login-success',
    component: DatapeopleAnywhereLoginSuccess,
  },
  {
    path: '/root',
    name: 'root',
    redirect: () => {
      //   update canary scripts and remove this check
      if (window.navigator.userAgent.endsWith('AWS-Canary-Noscript')) {
        return { name: 'published' };
      }
      return { name: 'home' };
    },
  },
  {
    path: '/:pathMatch(.*)',
    redirect: { name: 'root' },
  },
]);
